import {Card, DatePicker, Select, Skeleton, TimePicker} from "antd"
import React, {useEffect} from "react"
import {useClubCleanTableRecordContext} from "../store/useClubCleanTableRecordContext"
import moment from "moment";
import DisplayResult from "../../../util/DisplayResult";
import SkeletonInput from "antd/es/skeleton/Input";


const ClubCleanTableRecordSearch = () => {

    const {
        employeeListState,
        searchParamState,
        tableListState,
        onSearchParamChange,
        getEmployeeList,
        getTableList
    } = useClubCleanTableRecordContext()

    useEffect(() => {
        getEmployeeList()
        getTableList()
    }, [])

    return <div>
        <Card
            title={"检索条件"}
        >
            <div style={{display: 'flex', flexDirection: 'row', gap: 10}}>
                <SearchItem title={"时间范围"}
                            children={<DatePicker.RangePicker format={'YYYY-MM-DD'}
                                                              allowClear={false}
                                                              disabledDate={(current) => {
                                                                  return current > moment().endOf('day')
                                                              }}
                                                              value={[searchParamState.startTime, searchParamState.endTime]}
                                                              onChange={(time) => {
                                                                  onSearchParamChange({
                                                                      startTime: time[0].startOf('day'),
                                                                      endTime: time[1].endOf('day')
                                                                  })
                                                              }}/>}></SearchItem>
                <DisplayResult
                    state={employeeListState}
                    onSuccess={(data) => {
                        let options = [{
                            label: '全部',
                            value: 'all'
                        }]
                        options = options.concat(data.map((item) => ({
                            label: item.employee_name,
                            value: item.id
                        })))
                        return <SearchItem title={"员工"}
                                           children={
                                               <Select
                                                   style={{width: 200}}
                                                   options={options}
                                                   value={searchParamState.employeeId}
                                                   onChange={(value) => {
                                                       onSearchParamChange({
                                                           employeeId: value
                                                       })
                                                   }}
                                               ></Select>
                                           }>
                        </SearchItem>
                    }}
                    onLoading={() => {
                        return <SkeletonInput style={{width: 300}}></SkeletonInput>
                    }}
                    onError={(errorMessage) => {
                        return <Select status={"error"} placeholder={errorMessage}/>
                    }}

                />
                <DisplayResult
                    state={tableListState}
                    onSuccess={(data) => {
                        let options = [{
                            label: '全部',
                            value: 'all'
                        }]
                        options = options.concat(data.map((item) => ({
                            label: item.name,
                            value: item.table_id
                        })))
                        return <SearchItem title={"球台"}
                                           children={
                                               <Select
                                                   style={{width: 200}}
                                                   options={options}
                                                   value={searchParamState.tableId}
                                                   onChange={(value) => {
                                                       onSearchParamChange({
                                                           tableId: value
                                                       })
                                                   }}
                                               ></Select>
                                           }>
                        </SearchItem>
                    }}
                    onLoading={() => {
                        return <SkeletonInput style={{width: 300}}></SkeletonInput>
                    }}
                    onError={(errorMessage) => {
                        return <Select status={"error"} placeholder={errorMessage}/>
                    }}

                />

            </div>
        </Card>
    </div>
}

const SearchItem = (
    {title, children}
) => {
    return (
        <div style={{display: 'flex', flexDirection: 'row'}}>
            <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: 100}}>{title}：</div>
            <div style={{marginLeft: '10px'}}>{children}</div>
        </div>
    )
}


export default ClubCleanTableRecordSearch


// WEBPACK FOOTER //
// ./src/containers/ClubCleanTableRecord/component/ClubCleanTableRecordSearch.js